










import './KisweFormHeader.scss'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'KisweFormHeader',
  props: {
    title: {
      type: String,
      required: false
    }
  }
})
